<!-- @format -->

<ng-container *transloco="let t">
  <h2 class="fudis-heading__xl">
    {{ t("ENROLMENTS.SELECT_REALISATIONS") }}
  </h2>
  <div class="modal-header sis-mb-md">
    <div>
      <fudis-body-text [variant]="'md-light'">
        {{ t("ENROLMENTS.SELECT_REALISATIONS_HELP") }}
      </fudis-body-text>
    </div>
    <sis-modal-close-button />
  </div>
  <div class="modal-body">
    <div class="sis-mb-md">
      <h3>{{ t("ENROLMENT.SELECT_COURSE_UNIT_REALISATION_DIALOG.COURSE_UNIT_INFO_HEADING") }}</h3>
      <fudis-dl [variant]="'compact'">
        <fudis-dl-item>
          <fudis-dt [contentText]="t('ENROLMENTS.ENROLMENT_DIALOG.COURSE_UNIT')"></fudis-dt>
          <fudis-dd>
            <a
              fudisLink
              href="/student/courseunit/{{ courseUnit.id }}"
              [external]="true"
              title="{{ courseUnit.code }}, {{ courseUnit.name | localizedString }}"></a>
          </fudis-dd>
        </fudis-dl-item>
        <fudis-dl-item>
          <fudis-dt [contentText]="t('ENROLMENT.SELECT_COURSE_UNIT_REALISATION_DIALOG.COURSE_UNIT_VERSION_INFO')"></fudis-dt>
          <fudis-dd>
            {{ courseUnitVersionDisplayName | async }}
            <sis-popover
              [popoverText]="t('ENROLMENT.SELECT_COURSE_UNIT_REALISATION_DIALOG.COURSE_UNIT_VERSION_TOOLTIP')"
              popoverClass="dark"
              popoverPlacement="bottom"
              (shown)="isOpen()"
              (hidden)="isHidden()">
              <button
                type="button"
                class="non-button sis-popover-trigger-content"
                [attr.aria-label]="t('ARIA_LABEL.SHOW_DETAILS')"
                [attr.aria-expanded]="popoverShown">
                <sis-icon [icon]="'info-circle'" [color]="'primary'"></sis-icon>
              </button>
            </sis-popover>
          </fudis-dd>
        </fudis-dl-item>
        <fudis-dl-item>
          <fudis-dt [contentText]="t('ENROLMENTS.PLANNED_COMPLETION_METHOD')"></fudis-dt>
          <fudis-dd>
            {{ t("COMPLETION_METHOD") }} : {{ getCompletionMethodIndex() }}
            <sis-popover
              [popoverText]="t('ENROLMENTS.SELECT_COMPLETION_METHOD_INFO')"
              popoverClass="dark"
              popoverPlacement="bottom"
              (shown)="isOpen()"
              (hidden)="isHidden()">
              <button
                type="button"
                class="non-button sis-popover-trigger-content"
                [attr.aria-label]="t('ARIA_LABEL.SHOW_DETAILS')"
                [attr.aria-expanded]="popoverShown">
                <sis-icon [icon]="'info-circle'" [color]="'primary'"></sis-icon>
              </button>
            </sis-popover>
          </fudis-dd>
        </fudis-dl-item>
      </fudis-dl>
    </div>
    @for (entry of assessmentItemsWithRealisations | keyvalue; track entry) {
      <div class="sis-mb-md">
        <div class="flex-container">
          <h3>{{ entry.key.name | localizedString }} ({{ entry.key.credits | creditRange }})</h3>
          @if (hasAnyAttainment(entry.value, entry.key)) {
            <sis-icon icon="achievement" color="success"></sis-icon>
            <span>{{ t("COMPLETED") }}</span>
          }
        </div>
        @if (entry.value.length === 0) {
          <fudis-body-text [variant]="'md-light'">{{ t("COURSE_UNIT_INFO_MODAL.NO_UPCOMING_CUR") }}</fudis-body-text>
        } @else {
          @for (realisation of entry.value; track realisation) {
            <div
              class="realisation-container sis-mb-xs sis-pl-sm"
              [ngClass]="
                isCourseUnitRealisationSelected(realisation, entry.key) || hasAttainment(realisation, entry.key) ? 'selected' : 'unselected'
              ">
              <div class="row flex-container">
                <div class="col-md-6 col-xs-12">
                  <sis-checkbox
                    [label]="getCourseUnitRealisationLabel(realisation)"
                    [checked]="isCourseUnitRealisationSelected(realisation, entry.key) || hasAttainment(realisation, entry.key)"
                    (checkedChange)="courseUnitRealisationCheckboxClicked($event, realisation.id, entry.key.id)"
                    [ariaDescribedBy]=""
                    [disabled]="isSelectionDisabled(realisation, entry.key)">
                  </sis-checkbox>
                </div>
                <div class="col-md-6 col-xs-12">
                  <div class="badge-container flex-container">
                    @if (realisation.flowState === "CANCELLED") {
                      <sis-tiny-badge [content]="t('COURSE_UNIT_REALISATION.FLOWSTATE.CANCELLED')" [variant]="'danger'"></sis-tiny-badge>
                    }
                    @if (hasEnrolled(realisation)) {
                      <sis-tiny-badge
                        [content]="t('ENROLMENT.SELECT_COURSE_UNIT_REALISATION_DIALOG.ENROLMENT_ATTEMPTED')"
                        [variant]="'primary'"></sis-tiny-badge>
                    }
                    @if (enrolmentConfirmed(realisation) && !hasAttainment(realisation, entry.key)) {
                      <sis-tiny-badge
                        [content]="t('ENROLMENT.SELECT_COURSE_UNIT_REALISATION_DIALOG.ENROLMENT_SUCCEEDED')"
                        [variant]="'success'"></sis-tiny-badge>
                    }
                    @if (enrolmentRejected(realisation)) {
                      <sis-tiny-badge
                        [content]="t('ENROLMENT.SELECT_COURSE_UNIT_REALISATION_DIALOG.ENROLMENT_REJECTED')"
                        [variant]="'danger'"></sis-tiny-badge>
                    }
                    @if (hasAborted(realisation)) {
                      <sis-tiny-badge
                        [content]="t('ENROLMENT.SELECT_COURSE_UNIT_REALISATION_DIALOG.ENROLMENT_ABORTED')"
                        [variant]="'secondary'"></sis-tiny-badge>
                    }
                    @if (hasAttainment(realisation, entry.key)) {
                      <sis-tiny-badge [content]="t('ATTAINMENT_STATE.ATTAINED')" [variant]="'success'"></sis-tiny-badge>
                    }
                    @if (isEnrolledToFromAnotherEntity(realisation, entry.key)) {
                      <div class="flex-container">
                        <sis-tiny-badge
                          [content]="t('ENROLMENT.SELECT_COURSE_UNIT_REALISATION_DIALOG.IS_ENROLLED_TO_FROM_ANOTHER_ENTITY_TITLE')"
                          [variant]="'accent'"></sis-tiny-badge>
                        <sis-popover
                          [popoverText]="t('ENROLMENT.SELECT_COURSE_UNIT_REALISATION_DIALOG.IS_ENROLLED_TO_FROM_ANOTHER_ENTITY_TOOLTIP')"
                          popoverClass="dark"
                          popoverPlacement="bottom"
                          (shown)="isOpen()"
                          (hidden)="isHidden()">
                          <button
                            type="button"
                            class="non-button sis-popover-trigger-content"
                            [attr.aria-label]="t('ARIA_LABEL.SHOW_DETAILS')"
                            [attr.aria-expanded]="popoverShown">
                            <sis-icon [icon]="'info-circle'" [color]="'primary'"></sis-icon>
                          </button>
                        </sis-popover>
                      </div>
                    }
                  </div>
                </div>
              </div>
              <div class="sis-pl-md">
                <ul>
                  <li class="description-text">
                    <a
                      fudisLink
                      href="/student/courseunit/{{ courseUnit.id }}/completion-methods?courseUnitRealisation={{ realisation.id }}&tabId=0"
                      [external]="true"
                      [title]="t('ENROLMENT.SELECT_COURSE_UNIT_REALISATION_DIALOG.REALISATION_TIME_AND_PLACE_LINK_TEXT')"></a>
                  </li>
                </ul>
              </div>
            </div>
          }
        }
      </div>
    }
    <div>
      <h3 class="fudis-heading__md">{{ t("ENROLMENT.SELECT_COURSE_UNIT_REALISATION_DIALOG.AFTER_CONFIRM_HEADING") }}</h3>
      <fudis-body-text [variant]="'md-light'">
        {{ t("ENROLMENTS.REMEMBER_TO_ENROL") }}
      </fudis-body-text>
    </div>
  </div>
  <div class="modal-footer confirm-dialog-footer">
    <sis-button (clicked)="cancel()" [hollow]="true">{{ t("BUTTON.CANCEL") }}</sis-button>
    <sis-button dataCy="course-unit-realisation-selection-button" (clicked)="submit()">{{ t("BUTTON.CONFIRM") }}</sis-button>
  </div>
</ng-container>
